import React from 'react';
import './title.css'

import { useSelector } from 'react-redux';

export default function (){

    const title = useSelector( state => state.lesson.content.title );

    return(
        <div className='title'>
            <h2>{title}</h2>
        </div>
    )
}